<template>
  <img src="../assets/logo_sr_descripcion.png" alt="Logo" loading="lazy">
</template>

<script>
export default {
  name: 'Logo'
}
</script>

<style lang="scss" scoped>
  img {
    width: 225px;
  }
</style>